import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BaseChartDirective } from 'ng2-charts';
import { Chart } from 'chart.js';

import { MaterialModule } from './material.module';

import { GridComponent } from './components/grid/grid.component';
import { TagComponent } from './components/tag/tag.component';
import { LabelComponent } from './components/label/label.component';
import { DialogActionsComponent } from './components/dialog-actions/dialog-actions.component';
import { DialogContentComponent } from './components/dialog-content/dialog-content.component';
import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { IconComponent } from './components/icon/icon.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { ConfirmDirective } from './components/confirm/confirm.directive';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MessageComponent } from './components/message/message.component';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { TrendBadgeComponent } from './components/trend-badge/trend-badge.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { ChartPlaceholderComponent } from './components/chart-placeholder/chart-placeholder.component';
import { ToggleGroupComponent } from './components/toggle-group/toggle-group.component';
import { ToggleItemComponent } from './components/toggle-item/toggle-item.component';
import { ViessmannLogoComponent } from './components/viessmann-logo/viessmann-logo.component';
import { TableComponent } from './components/table/table.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { NumericStepperComponent } from './components/numeric-stepper/numeric-stepper.component';

import { MarkdownItPipe } from './pipes/markdown-it.pipe';
import { MessageTypeToIconPipe } from './pipes/message-type-to-icon.pipe';

import { ChartUtils } from './utils';
import { CurrencyPipe } from './pipes/currency.pipe';
import { ToggleComponent } from './components/toggle/toggle.component';

export function registerGlobalChartPluginsFactory() {
    return () => {
        Chart.register(ChartUtils.areaBorderPlugin);
    };
}

const COMPONENTS = [
    DrawerComponent,
    DialogActionsComponent,
    DialogContentComponent,
    DialogHeaderComponent,
    IconComponent,
    TagComponent,
    GridComponent,
    LabelComponent,
    ConfirmComponent,
    SpinnerComponent,
    MessageComponent,
    InfoBoxComponent,
    TrendBadgeComponent,
    BarChartComponent,
    LineChartComponent,
    ChartPlaceholderComponent,
    ToggleGroupComponent,
    ToggleItemComponent,
    ViessmannLogoComponent,
    TableComponent,
    MessageDialogComponent,
    ToggleComponent,
    NumericStepperComponent
];

const DIRECTIVES = [ConfirmDirective];

const PIPES = [MarkdownItPipe, MessageTypeToIconPipe, CurrencyPipe];

@NgModule({
    declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
    imports: [CommonModule, RouterModule, ReactiveFormsModule, MaterialModule, BaseChartDirective, TranslateModule],
    exports: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: registerGlobalChartPluginsFactory,
            multi: true
        }
    ]
})
export class ComponentsModule {}
